module.exports = __webpack_public_path__ + "img/qqicon.1458979b.png";